module.exports = __webpack_public_path__ + "static/media/hamburger.7fd29572.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/PrimaryNav/hamburger.svg
// module id = 332
// module chunks = 0